<template>
  <div class="flex flex-column">
    <span class="h3 bold">Options de pension</span>

    <div class="flex flex-column my2">
      <span class="h4 col-12 mb1"> Choisissez la date de début de la pension </span>
      <DatePicker class="col-4 mb1" :min="minDate()" @setDate="setSubscriptionStartDate" />
      <span class="col-12 h6 italic">L’abonnement commencera automatiquement à la date que vous sélectionnez ci-dessous.</span>
    </div>

    <div v-if="hasReservationOption" class="flex flex-column mt1">
      <span class="h4 col-12"> Sélectionnez le type de cheval utilisé pour les séances :</span>
      <div v-for="(option, index) in horseOptions" :key="index">
        <input type="radio" :checked="isSelected(option)" :name="option.label" @input="setHorseOption(option)">
        <span class="h5 bold">{{ option.label }}</span>
        <span class="h5"> {{ option.info }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format, addDays } from 'date-fns';
import { horseOptions } from '@/utils/utils';

import DatePicker from '@/components/elements/DatePicker.vue';

export default {
  components: { DatePicker },
  props: {},
  data () {
    return {
      workspace: this.$store.getters.workspace,
      horseOptions,
      horseOption: null
    };
  },
  computed: {
    cartItem () {
      return this.$store.state.cartItem;
    },
    hasReservationOption () {
      return (this.cartItem.tariffs || []).some(t => (t.options || []).some(o => o.withReservation));
    }
  },
  methods: {
    setSubscriptionStartDate (value) {
      this.$emit('subscriptionStart', value);
    },
    minDate () {
      return format(addDays(new Date(), 1), 'yyyy-MM-dd');
    },
    setHorseOption (value) {
      this.horseOption = value;
      this.$emit('setOptionHorse', value);
    },
    isSelected (option) {
      return option.value === this.horseOption?.value;
    }
  }
};

</script>

<style lang="scss" scoped>
input[type="radio"] {
  margin: 0.5rem;
}

input[type="radio"]::after{
  border: 1px solid var(--darkish-grey);
}

input[type="radio"]:checked::after{
  box-shadow: inset 0 0 0 2px var(--white);
  background-color: var(--strong-blue);
  border-color: var(--strong-blue)
}
</style>
